<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput label="New Password" type="password" invalid-feedback="New Password should be filled" required v-model="$v.changePasswordForm.new_password.$model" :is-valid="!$v.changePasswordForm.new_password.$invalid"/>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3">
                  <CInput label="Confirmation new password" type="password" invalid-feedback="Confirmation password should be filled" required v-model="$v.changePasswordForm.confirmation_new_password.$model" :is-valid="!$v.changePasswordForm.confirmation_new_password.$invalid"/>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CButton color="danger" @click="back">
          <i class="fa fa-undo"></i>
            Back
          </CButton>&nbsp;
          <CButton color="success" @click="submitForm" :disabled="$v.changePasswordForm.$invalid">
            <i class="fa fa-save"></i>
            Save
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required, sameAs } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../templates/Loading";
import custom_validation from "@/templates/_customValidation.js";
import Vuelidate from "vuelidate";
import * as moment from "moment";

export default {
  name: "changepassword",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Change Password",
      changePasswordForm: tableInterfaces.change_password,
      isLoading: false,
      isEdit: false,
      addButton: false,
    };
  },
  validations: {
    changePasswordForm: {
      new_password: { required },
      confirmation_new_password: { required,sameAsPassword: sameAs('new_password') }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
    },
    resetForm: function () {
      for (var i in tableInterfaces.change_password) {
        tableInterfaces.change_password[i] = null;
      }
      this.changePasswordForm = tableInterfaces.change_password;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault()
        this.changePasswordForm.user_code = localStorage.user_code;
        this.changePasswordForm.is_agent = localStorage.is_agent;
        if(confirm('Do you want to Change Password ?')){
					this.axios.put("console/change_password/edit/", this.changePasswordForm).then((response) => {
            this.showInfoNotification({
              title: "Change Password",
              message: response.data.message,
            });
          }).catch((error) => {
            //this.expired(error, "Ubah Product Issue");
          }).finally(() => {
            // this.isLoading = false;
            // let route = this.$route.path.split("/");
            // this.init(route[4]);
          });
				}
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
